const SET_URL_FIELD = 'url/SET_URL_FIELD'
const SET_URL_FIELDS = 'url/SET_URL_FIELDS'

export { SET_URL_FIELD, SET_URL_FIELDS }
